import "./associative.less";
import "./browser-hrm-list.less";
import "./browser-hrm-mult.less";
import "./browser-hrm.less";
import "./browser-mult.less";
import "./browser-single.less";
import "./browser-table.less";
import "./browser-tree.less";
import "./browser.less";
import "./index.less";
import "./group.less";



// WEBPACK FOOTER //
// ./ecology9/wea-browser/style/index.js